import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MessageCircle, ChevronRight } from "lucide-react";
import { api } from "@/lib/api";
import { colors } from "@/lib/theme";
import { commentTime } from "@/lib/date";
import { Avatar, Spinner } from "@/components/peeps/ui";
import { HomeButton } from "@/components/peeps/HomeButton";

export default function Messages() {
  const navigate = useNavigate();
  const [threads, setThreads] = useState(null);

  useEffect(() => { api.messageThreads().then(setThreads).catch(() => setThreads([])); }, []);

  return (
    <div className="min-h-screen" style={{ background: colors.surface }}>
      <div className="max-w-2xl mx-auto px-5 py-7 pb-24">
        <HomeButton />
        <h1 className="font-display font-bold text-3xl mt-4 mb-6" style={{ color: colors.onSurface }}>Messages</h1>

        {threads === null ? (
          <div className="py-20"><Spinner /></div>
        ) : threads.length === 0 ? (
          <div className="text-center py-16" data-testid="messages-empty">
            <MessageCircle size={30} color={colors.muted} className="mx-auto mb-3" />
            <p className="font-display text-[15px]" style={{ color: colors.onSurfaceTertiary }}>No conversations yet</p>
            <p className="font-display text-[13px] mt-1" style={{ color: colors.faint }}>Add a friend, then start a chat from their profile.</p>
          </div>
        ) : (
          <div className="flex flex-col gap-1.5" data-testid="messages-threads">
            {threads.map((t) => (
              <button
                key={t.user.id}
                data-testid={`thread-${t.user.id}`}
                onClick={() => navigate(`/messages/${t.user.id}`)}
                className="flex items-center gap-3 rounded-xl p-3 text-left transition-all hover:border-[#4A4B5C]"
                style={{ background: colors.surfaceSecondary, border: `1px solid ${colors.border}` }}
              >
                <div className="relative shrink-0">
                  <Avatar name={t.user.display_name} uri={t.user.profile_photo_url} size={44} />
                  {t.unread > 0 && (
                    <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full flex items-center justify-center font-display font-bold text-[10px]" style={{ background: colors.brand, color: colors.onBrand }}>
                      {t.unread > 9 ? "9+" : t.unread}
                    </span>
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between gap-2">
                    <span className="font-display font-bold text-[15px] truncate" style={{ color: colors.onSurface }}>{t.user.display_name}</span>
                    <span className="font-mono2 text-[10px] shrink-0" style={{ color: colors.faint }}>{commentTime(t.last_at)}</span>
                  </div>
                  <p className="font-display text-[13px] truncate mt-0.5" style={{ color: t.unread > 0 ? colors.onSurfaceSecondary : colors.onSurfaceTertiary, fontWeight: t.unread > 0 ? 600 : 400 }}>
                    {t.last_from_me ? "You: " : ""}{t.last_message}
                  </p>
                </div>
                <ChevronRight size={16} color={colors.muted} />
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
